import { defineNuxtPlugin } from 'nuxt/app';
import VueTippy from 'vue-tippy';

export default defineNuxtPlugin(({ vueApp }) => {
	vueApp.use(VueTippy, {
		directive: 'tippy',
		component: 'tippy',
		defaultProps: {
			theme: 'light',
		},
	});
});
